import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { RouteAction } from '@core/action/action';
import { ActivatedRoute } from '@angular/router';
import { MovimentacaoSocietariaService } from '@core/services/movimentacao-societaria.service';
import { forkJoin } from 'rxjs';
import { TipoEntidadesEnvolvidasEnum } from '@core/models/mudanca-societaria';
import { PaginationComponent } from '@shared/components/pagination/pagination.component';
import { ColumnOrder } from '@core/table/order';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { EntidadeEnvolvidaModalComponent } from '@modules/movimentacao-societaria/components/entidade-envolvida-modal/entidade-envolvida-modal.component';
import { FormService } from '@core/services/form.service';
import { converterItensVaziosEmNull, dataComDigitacao } from '@shared/util/util';
import { MessageService } from '@core/services/message.service';
import dayjs from 'dayjs';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { RoleEnum } from '@core/models/role';

@Component({
  selector: 'app-movimentacao-societaria-mudanca-societaria',
  templateUrl: './movimentacao-societaria-mudanca-societaria.component.html',
  styleUrls: ['./movimentacao-societaria-mudanca-societaria.component.scss']
})
export class MovimentacaoSocietariaMudancaSocietariaComponent implements OnInit {

  @ViewChild('formElement') formElement!: ElementRef;

  @Input() isModal: boolean = false;
  @Input() idEntidade!: number;
  @Input() entidade!: any;
  @Input() acao: RouteAction = RouteAction.Inserir;
  @Input() obj: any;
  @Input() form!: FormGroup;

  mudancaSocietariaForm!: FormGroup;
  movimentacaoSocietaria: any;
  nomePagina: NomePaginaEnum = NomePaginaEnum.ENTIDADE;

  tipoMudancaLista: any[] = [];
  entidadesLista: any[] = [];
  statusLista: any[] = [];
  statusMudancaEntidadeLista: any[] = [];

  tipoEntidadesEnvolvidasLista: any[] = [
    { id: 1, descricao: 'Única entidade' },
    { id: 2, descricao: 'Várias entidades' },
  ]

  idParams!: number;
  acaoEnum = RouteAction;
  inserir!: boolean;
  editar!: boolean;
  visualizar!: boolean;
  actionActual!: RouteAction
  tipoEntidadesEnvolvidasSelecionada!: TipoEntidadesEnvolvidasEnum;
  tipoEntidadesEnvolvidasEnum = TipoEntidadesEnvolvidasEnum;
  roleEnum = RoleEnum;
  dataSet: any[] = [];
  @ViewChild(PaginationComponent)
  paginator!: PaginationComponent;
  columOrder: ColumnOrder | undefined;
  dadosIdSelecionado: any;

  tipoMudancaSelecionado: any;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private movimentacaoSocietariaService: MovimentacaoSocietariaService,
    private modalService: NzModalService,
    private location: Location,
    private formService: FormService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.getParams();
    this.construirForm();
    this.carregarListas();
    console.log("MovimentacaoSocietariaMudancaSocietariaComponent "+this.entidade)
  }

  construirForm() {
    this.mudancaSocietariaForm = this.fb.group({
      exigeNotificacao: ['', false],
      dataMudancaEntidade: [''],
      tipoMudancaEntidade: ['', Validators.required],
      justificativaMudanca: ['', [Validators.maxLength(2000)]],
      entidadesEnvolvidas: [''],
      statusMudancaEntidade: [''],
      tipoEntidadesEnvolvidas: [undefined, Validators.required],
      entidadeDocumentos: [],
    });

    this.mudancaSocietariaForm.get('id')?.disable();

    this.tipoEntidadesEnvolvidas?.valueChanges.subscribe((val) => {
      if (val) {
        this.tipoEntidadesEnvolvidasSelecionada = val;
      }
    });

    this.tipoMudancaControl?.valueChanges.subscribe((val) => {
      if (val) {
        this.tipoMudancaSelecionado = val;
      }
    });

    this.dadosModal();
  }

  buscarDados() {
    if (!this.inserir && this.idParams || !this.inserir && this.obj?.id) {
      this.movimentacaoSocietariaService.consultarId(this.idParams ?? this.obj?.id)?.subscribe((res) => {
        this.movimentacaoSocietaria = res;

        if (res.entidadesEnvolvidas) {
          (res.entidadesEnvolvidas.length == 1)
            ? this.tipoEntidadesEnvolvidas?.setValue(TipoEntidadesEnvolvidasEnum.Unica)
            : this.tipoEntidadesEnvolvidas?.setValue(TipoEntidadesEnvolvidasEnum.Varias);
        }

        // console.log(this.movimentacaoSocietaria)
        this.dataSet = this.movimentacaoSocietaria.entidadesEnvolvidas;
        this.mudancaSocietariaForm.patchValue(this.movimentacaoSocietaria);
      })
    }
  }

  dadosModal() {
    if (this.isModal && this.idEntidade) {
      this.acao = this.obj?.id ? RouteAction.Editar : RouteAction.Inserir;
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
    }

    if(!this.editar && !this.visualizar) {
      if (this.idEntidade) {
        this.mudancaSocietariaForm.get('entidadeId')?.disable();
      }
      console.log(this.idEntidade);
      this.mudancaSocietariaForm.patchValue({
        entidadeId: this.idEntidade ?? null

      });

      this.dadosIdSelecionado = { ...this.mudancaSocietariaForm.getRawValue() };
    }

  }

  carregarListas() {
    forkJoin({
      statusMudanca: this.movimentacaoSocietariaService.statusMudancaEntidade(),
      tipoMudanca: this.movimentacaoSocietariaService.tipoMudancaEntidade()
    }).subscribe(({ statusMudanca, tipoMudanca }) => {
      this.statusLista = statusMudanca.slice(0, 2);
      this.tipoMudancaLista = tipoMudanca;

      this.buscarDados();
    });
  }

  dadosEntidadeEnvolvida(entidadeEnvolvida: any): void {
    this.mudancaSocietariaForm.get('entidadesEnvolvidas')?.setValue([entidadeEnvolvida]);
  }

  salvar() {
    if (!this.mudancaSocietariaForm) {
      this.messageService.warning(`O formulário não está inicializado.`);
      return;
    }

    const messages = this.formService.getValidationsMessages(this.mudancaSocietariaForm, this.formElement);
    this.formService.validateAllFormFields(this.mudancaSocietariaForm);

    if (this.mudancaSocietariaForm.get('tipoEntidadesEnvolvidas')?.value === TipoEntidadesEnvolvidasEnum.Unica) {
      const entidadesEnvolvidas = this.mudancaSocietariaForm.get('entidadesEnvolvidas')?.value;

      if (!entidadesEnvolvidas || !entidadesEnvolvidas.length) {
        this.messageService.warning(`Existem campos obrigatórios a serem preenchidos para entidades envolvidas.`);
        return;
      }
    }

    if (messages.length) {
      this.messageService.warning(`Existem campos obrigatórios a serem preenchidos.`);
      return;
    }

    let objSubmit = { ...this.mudancaSocietariaForm.getRawValue() };
    objSubmit.dataMudancaEntidade = dayjs(objSubmit.dataMudancaEntidade).toISOString();

    if (this.dataSet?.length) {
      objSubmit.entidadesEnvolvidas = this.dataSet;
    }

    if (objSubmit.entidadesEnvolvidas?.length <= 1 && objSubmit.tipoEntidadesEnvolvidas == TipoEntidadesEnvolvidasEnum.Varias) {
      this.messageService.warning(`Você precisa cadastrar mais uma entidade envolvida!`);
      return;
    }

    if(objSubmit.entidadesEnvolvidas.length) {
      objSubmit.entidadesEnvolvidas?.forEach((item: any) => {
        if (item.emails && typeof item.emails === 'string' && item.emails.includes(',')) {
          if (!Array.isArray(item.emails)) {
            item.emails = item.emails.split(',');
          }
        }

        if (item.entidade && typeof item.entidade === 'object' && item.entidade?.id) {
          item.entidadeId = item.entidade?.id;
        }
      });
    }

    objSubmit.exigeNotificacao = objSubmit.entidadesEnvolvidas[0]?.deveNotificar;

    objSubmit = converterItensVaziosEmNull(objSubmit);
    console.log(objSubmit)


    if (this.mudancaSocietariaForm.valid) {
      switch (this.acao) {
        case RouteAction.Inserir:
          this.salvarCallback(objSubmit);
          break;
        case RouteAction.Editar:
          this.editarCallback(objSubmit);
          break;
      }
    } else {
      this.messageService.error('Existem campos obrigatórios a serem preenchidos.');
    }
  }

  salvarCallback(obj: any) {
    this.movimentacaoSocietariaService.salvar(obj).subscribe((res) => {
      this.messageService.success('Salvo com sucesso!');
      this.voltar();
    });
  }

  editarCallback(obj: any) {
    obj.id = this.idParams ?? this.obj?.id;
    this.movimentacaoSocietariaService.editar(obj).subscribe((res) => {
      this.messageService.success('Editado com sucesso!');
      this.voltar();
    });
  }

  reverter() {

  }

  showModal(obj?: any): void {
    const config: ModalOptions<EntidadeEnvolvidaModalComponent> = {
      nzTitle: 'Entidade Envolvida',
      nzContent: EntidadeEnvolvidaModalComponent,
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzWidth: '49vw',
      nzClosable: false
    };
    const modalRef = this.modalService.create(config);
    modalRef.componentInstance!.entidadeEnvolvida = obj;
    modalRef.componentInstance!.idEntidade = this.idEntidade ? this.idEntidade : null;
    modalRef.componentInstance!.entidade = this.entidade ? this.entidade : null;
    modalRef.componentInstance!.tipoEntidadesEnvolvidasSelecionada = this.tipoEntidadesEnvolvidasSelecionada;
    modalRef.componentInstance!.acao = obj ? RouteAction.Editar : RouteAction.Inserir;

    modalRef.afterClose.subscribe((result: any) => {
      if (result) {
        if (obj) {
          const index = this.dataSet.findIndex(item => item.id === obj.id);
          this.dataSet[index] = result;
        } else {
          this.dataSet.push(result);
        }
      }
    });
  }

  remover(obj?: any): void {
    const index: number = this.dataSet.indexOf(obj);
    if (index !== -1) {
      this.dataSet.splice(index, 1);
    }
  }

  tipoEntidadesEnvolvidasSelecionadaChange(item: any) {
    console.log(item)
    this.entidadesEnvolvidasControl?.setValue([item]);
  }

  sort(event: any) {
    const column = event.sort.find((x: any) => x.value);
    if (column) {
      const sortKey = column.key;
      const sortOrder = column.value === 'ascend' ? 1 : -1;

      this.dataSet = [...this.dataSet].sort((a, b) => {
        const valueA = this.getNestedValue(a, sortKey);
        const valueB = this.getNestedValue(b, sortKey);

        if (valueA < valueB) {
          return -1 * sortOrder;
        }
        if (valueA > valueB) {
          return 1 * sortOrder;
        }
        return 0;
      });
    } else {
      this.dataSet = [...this.dataSet];
    }
  }

  getNestedValue(obj: any, key: string): any {
    return key.split('.').reduce((o, k) => (o ? o[k] : null), obj);
  }

  compareFn(a: any, b: any) {
    if (a?.id == undefined && b?.id) {
      return a === b.id;
    }
    if (a?.id && b?.id) {
      return a.id === b.id;
    }
    else {
      return a === b;
    }
  }

  voltar(): void {
    (this.isModal)
      ? this.modalService.closeAll()
      : this.location.back();
  }

  getParams(service?: any) {
    this.route.params.subscribe((data) => {
      this.idParams = data['id'];
    })

    this.route.data.subscribe((data: any) => {
      this.acao = data?.acao;
      this.inserir = this.acao == RouteAction.Inserir;
      this.editar = this.acao == RouteAction.Editar;
      this.visualizar = this.acao == RouteAction.Visualizar;

      // console.log(this.inserir, this.editar, this.visualizar)
    });
  }

  onInputDateChange(inputValue: any, campo: string): void {
    dataComDigitacao(inputValue, this.mudancaSocietariaForm, campo);
  }

  get tipoEntidadesEnvolvidas() {
    return this.mudancaSocietariaForm.get('tipoEntidadesEnvolvidas');
  }

  get tipoMudancaControl() {
    return this.mudancaSocietariaForm.get('tipoMudancaEntidade');
  }

  get entidadesEnvolvidasControl() {
    return this.mudancaSocietariaForm.get('entidadesEnvolvidas');
  }

  get testeControl() {
    const entidadesEnvolvidas = this.mudancaSocietariaForm?.get('entidadesEnvolvidas') as FormArray;
     const test =  entidadesEnvolvidas?.value[0]?.entidade?.nomeFantasia

    return test;
  }

}
